import * as exBootstrap from '../../../bootstrap';

// ----------------------------------------------------------------------------

function show(element: HTMLElement, config: Record<string, any> = {}): void {
    exBootstrap.show('Dropdown', element, config);
}

// ----------------------------------------------------------------------------

export default show;
